<div class="grid h-screen">
  <div class="col-12 md:col-4">
    <div class="card widget-overview-box widget-overview-box-1 apcard">
      <div class="col-12">
        <div class="flex justify-content-between mb-3">
          <span class="block text-500 font-medium mb-3">Current Users</span>
                <div class="flex align-items-center justify-content-center border-round"
              style="width: 2.5rem; height: 2.5rem;">
            <i class="pi pi-users text-green-500 text-xl"></i>
          </div>
        </div>
        <div class="w-full">
          <div class="text-900 font-large text-green-500 text-xl">
            <h3>{{ currentUserCount }}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
